import { render } from "./FooterComp.vue?vue&type=template&id=5bb86a54&scoped=true"
import script from "./FooterComp.vue?vue&type=script&lang=js"
export * from "./FooterComp.vue?vue&type=script&lang=js"

import "./FooterComp.vue?vue&type=style&index=0&id=5bb86a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb86a54"]])

export default __exports__